export const lsSetItem = (key, data) => {
    try {
        localStorage.setItem(key, data);
    }
    catch (e) { }
};
export const lsGetItem = (key) => {
    let data = null;
    try {
        data = localStorage.getItem(key);
    }
    catch (e) { }
    return data;
};
export const lsRemoveItem = (key) => {
    try {
        localStorage.removeItem(key);
    }
    catch (e) { }
};
